/* eslint-disable react/forbid-prop-types,jsx-a11y/alt-text */
import { useState } from 'react';
import PropTypes from 'prop-types';
import { DEFAULT_TAG } from 'consts/defaultImages';

const MIN_IMG_SIZE = 20;

// mainSrc - the main tag image
// secondarySrc - the second tag image, for example the tag has images for the slider
// backupSrc - usually the retailer's logo
const TagImage = ({ mainSrc, secondarySrc, backupSrc, objectFit, style, ...rest }) => {
  const [src, setSrc] = useState(mainSrc);

  const onErrorHandler = () => {
    if (secondarySrc && src === mainSrc) {
      setSrc(secondarySrc);

      return;
    }

    if (backupSrc && src !== backupSrc && src !== DEFAULT_TAG) {
      setSrc(backupSrc);

      return;
    }

    setSrc(DEFAULT_TAG);
  };

  const onLoadHandler = e => {
    // need to check only scraped images, as they may not be correct
    if ([backupSrc, DEFAULT_TAG].includes(src)) return;

    const img = e.target;
    const minImgSize = Math.min(img.naturalHeight, img.naturalWidth);

    // the image is big enough to be a product image
    if (minImgSize > MIN_IMG_SIZE) return;

    if (secondarySrc && src === mainSrc) {
      setSrc(secondarySrc);

      return;
    }

    if (backupSrc) {
      setSrc(backupSrc);

      return;
    }

    setSrc(DEFAULT_TAG);
  };

  return (
    // Component can NOT be styled-component, because it will filter necessary attributes (e.g. fetchPriority="high")
    <img
      src={src}
      onError={onErrorHandler}
      onLoad={onLoadHandler}
      style={{
        width: '100%',
        height: '100%',
        objectFit: src === backupSrc ? 'scale-down' : objectFit,
        objectPosition: 'center',
        ...style,
      }}
      {...rest}
    />
  );
};

TagImage.propTypes = {
  mainSrc: PropTypes.string.isRequired,
  secondarySrc: PropTypes.string,
  backupSrc: PropTypes.string.isRequired,
  objectFit: PropTypes.oneOf(['fill', 'contain', 'cover', 'none', 'scale-down', 'initial']),
  style: PropTypes.object,
};

TagImage.defaultProps = {
  secondarySrc: undefined,
  objectFit: 'cover',
  style: {},
};

export default TagImage;
